module.exports = __webpack_public_path__ + "img/03.b9503ee0.jpg";